import React from "react";
import { graphql, Link, useStaticQuery } from "gatsby";

const nameToIcon = {
  Twitter: (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-twitter inline-block w-5 h-5"
    >
      <path d="M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724 9.864 9.864 0 01-3.127 1.195 4.916 4.916 0 00-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.978 13.978 0 011.671 3.149a4.93 4.93 0 001.523 6.574 4.903 4.903 0 01-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.935 4.935 0 01-2.224.084 4.928 4.928 0 004.6 3.419A9.9 9.9 0 010 19.54a13.94 13.94 0 007.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10.025 10.025 0 0024 4.557z"></path>
    </svg>
  ),
  Github: (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-github inline-block w-5 h-5"
    >
      <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"></path>
    </svg>
  ),
  LinkedIn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      className="inline-block w-5 h-5"
    >
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
  ),
  Email: (
    <svg
      className="hi-solid hi-mail inline-block w-5 h-5"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
    </svg>
  ),
  Resume: (
    <svg
      className="hi-solid hi-document-text inline-block w-5 h-5"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
        clipRule="evenodd"
      />
    </svg>
  ),
};

const Footer = () => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        data: siteMetadata {
          menu {
            name
            to
          }
          socials {
            name
            to
          }
        }
      }
    }
  `);
  return (
    <footer
      id="footer"
      className="border-t border-gray-200 bg-white text-sm font-medium text-gray-600"
    >
      <div className="flex flex-col md:flex-row-reverse md:justify-between gap-8 md:gap-0 md:items-center text-center md:text-left container xl:max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-14 lg:px-8">
        <nav
          className="flex justify-center md:justify-end items-center gap-5"
          aria-label="Social links"
        >
          {site.data.socials.map(({ name, to }, key) => {
            const socialClass =
              "inline-flex items-center justify-center p-2 -m-2 text-gray-600 hover:text-gray-900 transition-colors duration-200";
            return name === "Resume" ? (
              <a href={to} key={`social-${key}`} className={socialClass}>
                <span className="sr-only">{name}</span>
                {nameToIcon[name]}
              </a>
            ) : (
              <a
                href={to}
                target="_blank"
                rel="noreferrer"
                key={`social-${key}`}
                className={socialClass}
              >
                <span className="sr-only">{name}</span>
                {nameToIcon[name]}
              </a>
            );
          })}
        </nav>
        <nav className="flex flex-wrap justify-center md:justify-start items-center gap-x-8 gap-y-2">
          {site.data.menu.map(({ name, to }, key) =>
            to !== "/" ? (
              <Link
                to={to}
                key={`footer-nav-${key}`}
                className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors duration-200"
              >
                {name}
              </Link>
            ) : null
          )}
        </nav>
        <div>dpmartintech.com</div>
      </div>
    </footer>
  );
};

export default Footer;
